import { LoginType, MsalAuthProvider } from 'react-aad-msal';

const config = {
  auth: {
    authority: window.ENV.AD_AUTHORITY,
    clientId: window.ENV.AD_CLIENT_ID,
    redirectUri: window.ENV.AD_REDIRECT_URI,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true
  }
};

const authenticationParameters = {
  scopes: window.ENV.AD_API_SCOPES
}

export const authProvider = new MsalAuthProvider(config, authenticationParameters, LoginType.Redirect)
